export default {
  data: function() {
    return {
      fortuneWheelPrize: '',
    }
  },
  methods: {
    registerWheelEventBusEvents() {
      this.$eventBus.$on('trigger-wheel-spin-validation', () => {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        this.$eventBus.$emit('trigger-wheel-spin')
      })

      this.$eventBus.$on('fortune-wheel-answer', (data) => {
        this.fortuneWheelPrize = data.value
        this.triggerChangeStep('next')
      })
    },
  },
}
